"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingOptOutModal = void 0;
const React = __importStar(require("react"));
const Modal_1 = require("../../modal/Modal");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const Button_1 = require("../../button/Button");
const SmartPricingOptOutModal = ({ isOpen, onClose, optOutOfSmartPricing }) => {
    if (!isOpen)
        return null;
    const CancelButton = React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Neutral, onClick: onClose }, "Cancel");
    const OffButton = (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: () => {
            optOutOfSmartPricing();
            onClose();
        } }, "Turn off"));
    return (React.createElement(Modal_1.Modal, { title: "Smart Pricing", onRequestClose: onClose, actionLHS: CancelButton, actionRHS: OffButton },
        React.createElement(Heading_1.HeadingSmall, null, "Are you sure you want to turn off smart pricing?"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "We'll restore your previous pricing periods to make sure you stay bookable.")));
};
exports.SmartPricingOptOutModal = SmartPricingOptOutModal;
//# sourceMappingURL=SmartPricingOptOutModal.js.map